<script lang="ts">
import SICCodesAutocompleteInput from './SICCodesAutocompleteInput.vue';
import { Label } from 'reka-ui';
import DatePicker from './DatePicker.vue';
import { type DateValue } from '@internationalized/date';

export default {
  name: 'Playground',
};
</script>

<script setup lang="ts">
import { ref } from 'vue';
import ManagedDateRange from '@/components/ManagedDateRange.vue';
import type { DateChangePayload } from '@/types/components/DateChangePayload';

const sicCode = ref<string>('');
const startDate = ref<Date>(new Date());
const endDate = ref<Date>(new Date());

const datePickerDate = ref<DateValue>();

function handleDateApply(payload: DateChangePayload) {
  if (payload.startDate) startDate.value = payload.startDate;
  if (payload.endDate) endDate.value = payload.endDate;
}
</script>

<template>
  <div class="flex h-full w-1/2 flex-col items-stretch gap-8 p-4">
    <div>
      <div>SIC Codes Autocomplete</div>
      <SICCodesAutocompleteInput v-model="sicCode" />
    </div>
    <div>
      
    </div>
    

    <div class="mt-4">
      <managed-date-range
        :initial-start-date="startDate"
        :initial-end-date="endDate"
        :on-apply="handleDateApply" />
    </div>

    <div class="flex flex-col gap-2">
      <Label class="text-sm" for="date-field">Date Picker</Label>
      <DatePicker v-model="datePickerDate"/>
    </div>
  </div>
</template>
